<template>

<div
  class="select select-combobox filter-select"
  :class="{isOpen: isOpen}"
  role="combobox"
  aria-haspopup="true"
  aria-expanded="false"
  >
  <button
    class="button select__trigger"
    aria-expanded="false"
    @click="toggleSelect()"
  >
    <div class="select__labels">
      <p class="select__labels-placeholder">{{ selectLabel }}</p>
      <p class="select__labels-selected fs-12 text-KQ-Grey2">
        <slot name="selectcount">0 Selected</slot>
      </p>
    </div>
    <i class="icon icon-triangle desktop"></i>
  </button>
  <ul class="select__dropdown select-combobox__dropdown">
    <slot
      name="comboboxDropdownContent"
      :toggleSelect="toggleSelect"
    ></slot>
  </ul>
</div>

</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch, inject } from 'vue';

const injectedIsOpen = inject(props.injectionName);

const props = defineProps({
  selectLabel: {
    type: String,
    default: 'Select'
  },
  injectionName: {
    type: String,
    default: 'injectedIsOpen'
  }
});

const emit = defineEmits(['select-toggled']);
const isOpen = ref(false);

const toggleSelect = (value = !isOpen.value) => {
  emit('select-toggled', value, props.selectLabel);
  isOpen.value = value;
}

const addClickOutsideListener = () => {
  document.addEventListener('click', handleClickOutside);
};

const removeClickOutsideListener = () => {
  document.removeEventListener('click', handleClickOutside);
};

const handleClickOutside = (event) => {
  const target = event.target;
  const selectElements = document.querySelectorAll('.filter-select');

  if (
    !Array.from(selectElements).some((element) => element.contains(target))
  ) {
    isOpen.value = false;
  }
};

onMounted(() => {
  addClickOutsideListener();
}) 

onBeforeUnmount(() => {
  removeClickOutsideListener();
})

watch(
    () => injectedIsOpen?.value,
    () => {
      isOpen.value = injectedIsOpen.value;
    },
  );
</script>